import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { BsFillDisplayFill, BsPhone, BsTablet } from 'react-icons/bs'
import { useHistory } from 'react-router-dom';
import http, { rootApi } from '../../../config/BaseUrl';
import ScreenLoader from '../../../components/Loader/ScreenLoader';
import TemplateOne from './SocialGallery/TemplateOne';
// import TemplateTwo from './SocialGallery/TemplateTwo';
// import TemplateThree from './SocialGallery/TemplateThree';
import Modal from 'react-modal'
import './Style/style.css'
import { HexColorPicker } from "react-colorful";
import TemplateThree from './SocialGallery/TemplateThree';
import TemplateTwo from './SocialGallery/TemplateTwo';
import { Editor } from '@tinymce/tinymce-react';


function EditSocialShare() {

  const customStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgb(0 0 0 / 80%)',
      zIndex: 100,
      width: '500x',
    },
    content: {
      position: 'relative',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '500px',
      overflow: 'hidden'

    },
    closeBtn: {
      position: 'absolute',
      top: 0,
      right: '-1%',
      background: 'transparent',
      border: 'none',
      color: 'red'
    }


  };
  const { id, social_id } = useParams()

  const history = useHistory();

  const dispatch = useDispatch()

  const editorRef = useRef()
  // const { CKEditor, ClassicEditor } = editorRef.current || {}

  const [customizeText, setCustomizeText] = useState(null)
  const [customizeData, setCustomizeData] = useState(null)
  const [fromStateName, setFromStateName] = useState(null)
  const [fromState, setFromState] = useState(null)
  const [templateDetail, setTemplateDetail] = useState(null)
  const [deviceView, setDeviceView] = useState('desktop-view')
  const [reset, setReset] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingContent, setLoadingContent] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [templateName, setTemplateName] = useState(null)
  const [templateNameError, setTemplateNameError] = useState(false)
  const [logoError, setLogoError] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(false)

  useEffect(() => {
    // editorRef.current = {
    //   // CKEditor: require('@ckeditor/ckeditor5-react'), // depricated in v3
    //   CKEditor: require('@ckeditor/ckeditor5-react').CKEditor,
    //   ClassicEditor: require('@ckeditor/ckeditor5-build-classic')
    // }
  }, [])


  useEffect(() => {
    setLoading(true)
    setLoadingContent("Loading. Please Wait.")
    http.get(`get-micro-site-template-sample/${id}`)
      .then(res => {
        setTemplateDetail(res.data.template);
        setLoadingContent("Loaded.")
        setLoading(false)

        let data = { id: res.data.template.id, image: res.data.template.template_image }

        setSelectedTemplate(data)

      })
      .catch(err => {
        console.log(err.response);
      })

  }, [])

  const resetEmailTemplate = () => {
    setReset(true);
    setCustomizeText('')
    setFromState('')
    setTimeout(() => {
      setReset(false)
    }, 1000)
  }

  const setChangeState = (stateName, theValue) => {
    setCustomizeText(theValue)
    setFromState(theValue)
    setFromStateName(stateName)
  }

  useEffect(() => {
    if (customizeText && customizeText !== fromState) {
      setFromState(customizeText)
    }
  }, [customizeText])

  const copyEditedData = (data) => {
    setCustomizeData(data)
  }

  const saveTemplate = () => {
    setTimeout(() => {
      if (social_id) {
        history.push(`/event/microsite/edit/${social_id}`, { editedData: { content: customizeData, social_id: social_id, template: selectedTemplate, saveAs: 'edited' } })
      } else {
        history.push(`/event/microsite`, { editedData: { content: customizeData, social_id: null, template: selectedTemplate, saveAs: 'edited' } })
      }
    }, 1000)

  }


  const saveChanges = () => {
    if (templateName) {
      setModalIsOpen(true)
    }
    else {
      setTemplateNameError(true)
      setTimeout(() => {
        setTemplateNameError(false)
      }, 3000)
    }
  }


  const saveTemplateByName = () => {
    setModalIsOpen(false)
    setLoading(true)
    setLoadingContent("Loading. Please Wait.")

    const submittedData = {
      name: templateName,
      microsite_template_id: id,
      contents: customizeData
    }

    http.post(`save/my/social-gallery-template`, submittedData)
      .then(res => {
        setLoadingContent(res.data.message)
        setTimeout(() => {
          setLoading(false)

          let editedData = {
            content: customizeData,
            social_id: social_id,
            template: { ...selectedTemplate, my_social_gallery_id: res.data.data.id },
            saveAs: 'my_template',
            my_social_gallery_id: res.data.data.id
          }

          if (social_id) {
            history.push(`/event/microsite/edit/${social_id}`, { editedData: editedData })
          } else {
            history.push(`/event/microsite`, { editedData: editedData })
          }
        }, 3000)
      })
      .catch(err => {
        console.log(err.response);
      })

  }

  const changeLogo = (e) => {
    let fileReader = new FileReader();

    if (e.target.files[0].size < 50000) {
      fileReader.readAsDataURL(e.target.files[0]);

      fileReader.onload = (e) => {
        setFromState(e.target.result)
        setLogoError(null)
      };
    }
    else {
      setLogoError('File size must be below to 50kb.')
    }

  }

  const removeImage = () => {
    setFromState(null)
    setLogoError(null)
  }


  return (
    <div className="edit-template">
      {
        !loading ?
          <>
            <div className="customize-sidebar">
              <div className="sidebar-actions">
                <button
                  className="btn btn-outline-primary"
                  onClick={saveTemplate}
                >Save</button>
                <button className="btn btn-outline-danger" onClick={resetEmailTemplate}>Reset</button>
                <button className="btn btn-outline-secondary" onClick={e => {
                  social_id ?
                    history.push(`/event/microsite/edit/${social_id}`)
                    : history.push(`/event/microsite`)
                }}>Cancel</button>
              </div>

              <div className="save-template-body">
                <div className="sidebar-section">
                  <div className="sidebar-section-header">
                    <h4>Save Changes</h4>
                  </div>
                  <div className="sidebar-section-content">
                    <p className="text-secondary">Save this template and add it to your personal library</p>
                    <div className="save-changes-area">
                      <input type="text" name="template-name" onChange={e => setTemplateName(e.target.value)} value={templateName} />
                      <button type="button" onClick={saveChanges}>Save</button>
                    </div>
                    {
                      templateNameError &&
                      <p className="text-danger">Name field is required.</p>
                    }
                  </div>
                </div>
              </div>

              <div className="configure-layout">
                <div className="sidebar-section">
                  <div className="sidebar-section-header">
                    <h4>Configure Layout</h4>
                  </div>
                  <div className="sidebar-section-content">
                    <div className="configure-area">
                      <p className="text-secondary">Choose a preview layout</p>
                      <div className="device-list">
                        <span className={`device-icon ${deviceView === "mobile-view" ? "device-active" : ""}`} data-toggle="tooltip" data-placement="top" title="Mobile Device" onClick={e => setDeviceView('mobile-view')}>
                          <BsPhone />
                        </span>
                        <span className={`device-icon ${deviceView === "tab-view" ? "device-active" : ""}`} data-toggle="tooltip" data-placement="top" title="Tab" onClick={e => setDeviceView('tab-view')}>
                          <BsTablet />
                        </span>
                        <span className={`device-icon ${deviceView === "desktop-view" ? "device-active" : ""}`} data-toggle="tooltip" data-placement="top" title="Big Screen" onClick={e => setDeviceView('desktop-view')}>
                          <BsFillDisplayFill />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="customized-section">
                <div className="sidebar-section">
                  <div className="sidebar-section-header">
                    <h4>Customize Section</h4>
                  </div>

                  <div className="editable-item">
                    <p className="text-secondary">
                      Editable elements are denoted by the green-dotted borders. Images, text and video links can be customized, simply click on an element to begin editing.
                      To preview your content without the green-dotted borders, click below:
                    </p>
                    {
                      fromStateName !== 'logo' && fromStateName !== 'SocialMenuStyle' &&
                      <Editor
                        apiKey="xvb4efuqq2rl9d94jli2tb8hvkydbjs9hkbqxjkzhjm44e5e"
                        onInit={(evt, editor) => editorRef.current = editor}
                        initialValue=""
                        value={customizeText}
                        init={{
                          height: 200,
                          menubar: false,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount'
                          ],
                          toolbar: 'undo redo | formatselect | ' +
                            'bold italic backcolor | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | ' +
                            'removeformat | help',
                          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                        onEditorChange={(newValue, editor) => setCustomizeText(newValue)}
                      />
                    }



                    {
                      fromStateName == 'SocialMenuStyle' &&
                      <div className="color-picker-body my-2">
                        <p className="mb-2">Change Color</p>
                        <HexColorPicker color={fromState} onChange={setFromState} />
                      </div>
                    }

                    {
                      fromStateName == 'logo' &&
                      <div className="edit-image">
                        <div className="edit-image-preview" style={{ display: 'grid', alignItems: 'center', justifyContent: 'center' }}>
                          <img src={fromState} className="img-fluid" style={{ maxWidth: `100%`, height: '80px' }} alt="selected-item" />
                        </div>
                        <div className="error-section">
                          {
                            logoError &&
                            <p className="text-danger">{logoError}</p>
                          }
                        </div>
                        <div className="edit-image-action">
                          <div className="insert-image" style={{ position: 'relative' }}>
                            <button className="btn btn-primary btn-block button-insert">Change</button>
                            <input
                              type="file"
                              className="file-with-button"
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                opacity: 0,
                              }}
                              onChange={changeLogo}
                            />
                          </div>
                          <button className="btn btn-secondary btn-block mt-3" onClick={removeImage}>remove</button>
                        </div>
                      </div>
                    }


                  </div>

                </div>
              </div>

              <Modal
                isOpen={modalIsOpen}
                style={customStyles}
                contentLabel="Example Modal"
              >
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="my-5">
                        <h4 className="text-center">Are You Sure!</h4>
                        <p className="text-center">This template will be selected as current template.</p>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button type="button" className="mr-2 btn btn-secondary" onClick={() => setModalIsOpen(false)} > Cancel </button>
                        <button type="button" className="btn btn-primary" onClick={saveTemplateByName}>Save Changes</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

            </div>
            <div className="template">
              <div className="template-body">
                <div className={`template-view ${deviceView}`}>
                  {
                    templateDetail && templateDetail.template_name == "three" ?
                      <TemplateThree setChangeState={setChangeState} changeStateData={fromState} reset={reset} copyEditedData={copyEditedData} />
                      : templateDetail && templateDetail.template_name == "two" ?
                        <TemplateTwo setChangeState={setChangeState} changeStateData={fromState} reset={reset} copyEditedData={copyEditedData} />
                        :
                        <TemplateOne setChangeState={setChangeState} changeStateData={fromState} reset={reset} copyEditedData={copyEditedData} />
                  }
                </div>
              </div>
            </div>
          </>
          : <ScreenLoader loadingContent={loadingContent} />
      }


    </div>
  )
}

export default EditSocialShare
